import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Cooperation } from "@/components/Cooperation";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { Partners } from "@/components/Partners";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { ProfessionalPopup } from "@/components/ProfessionalPopup";

export default function HomePage() {
  return (
    <main className="min-h-screen">
      <ProfessionalPopup />
      <Navigation />
      <Hero />
      <Cooperation />
      <About />
      <Services />
      <WhyUs />
      <Partners />
      <Contact />
      <Footer />
    </main>
  );
}
